import { api } from './index'

export type Suppression = {
  id: number
  identifier: string | null
  identifier_type: string
  reason: string
  suppressed_at: string
}

export const suppressionsApi = api.injectEndpoints({
  endpoints: builder => ({
    getSuppressions: builder.query<{ suppressions: Suppression[] }, void>({
      query: () => 'suppressions',
      providesTags: ['Suppression'],
    }),
  }),
})

export const { useGetSuppressionsQuery } = suppressionsApi
